import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { imgLoader } from 'Bem/site/img-loader/img-loader';
import 'Vendor/owlcarousel/owl.carousel.min';

const cOwl = 'owl-carousel';
const $salesMain = $('.sales-main');

function setSlider() {
    if (getW() > eksmoBP.xsMax) {
        $salesMain.trigger('destroy.owl.carousel')
            .removeClass(cOwl)
            .addClass(cOwl)
            .owlCarousel({
                items: 3,
                slideBy: 1,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                navClass: ['sales-main__arrow-prev arrow arrow_prev arrow_shadow', 'sales-main__arrow-next arrow arrow_next arrow_shadow'],
                navText: ['', ''],
                margin: 40,
                nav: true,
                dots: false,
                onInitialized() {
                    imgLoader();
                },
            });
    } else {
        $salesMain.trigger('destroy.owl.carousel');
    }
}

setSlider();
$('body').on('eksmoResizeWidth', setSlider);